// Reconstructed from the supplied production build; original component names were unavailable.
import { axios } from "../vendor/runtime.js";
import { API_BASE_URL } from "../config.js";
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  timeout: 3e4,
});
let isRefreshing = false;
let refreshQueue = [];
const processRefreshQueue = (e, t = null) => {
  (refreshQueue.forEach((n) => {
    e ? n.reject(e) : n.resolve(t);
  }),
    (refreshQueue = []));
};
const refreshAccessToken = async () => {
  try {
    const e = localStorage.getItem("refreshToken");
    if (!e) throw new Error("No refresh token available");
    const t = await axios.post(API_BASE_URL + "/auth/refresh", {
        refresh_token: e,
      }),
      { access_token: n, refresh_token: r } = t.data;
    return (localStorage.setItem("token", n), r && localStorage.setItem("refreshToken", r), n);
  } catch (e) {
    throw (
      console.error("Token refresh failed:", e),
      localStorage.removeItem("token"),
      localStorage.removeItem("refreshToken"),
      window.dispatchEvent(new CustomEvent("auth:failed")),
      e
    );
  }
};
api.interceptors.request.use(
  (e) => {
    const t = localStorage.getItem("token");
    return (t && (e.headers.Authorization = `Bearer ${t}`), e);
  },
  (e) => Promise.reject(e),
);
api.interceptors.response.use(
  (e) => e,
  async (e) => {
    const t = e.config;
    if (e.response && e.response.status === 401 && !t._retry) {
      if (isRefreshing)
        return new Promise((n, r) => {
          refreshQueue.push({
            resolve: n,
            reject: r,
          });
        })
          .then((n) => ((t.headers.Authorization = `Bearer ${n}`), api(t)))
          .catch((n) => Promise.reject(n));
      ((t._retry = true), (isRefreshing = true));
      try {
        const n = await refreshAccessToken();
        return (processRefreshQueue(null, n), (t.headers.Authorization = `Bearer ${n}`), api(t));
      } catch (n) {
        return (
          processRefreshQueue(n, null),
          window.location.pathname.includes("login") || (window.location.href = "/login"),
          Promise.reject(n)
        );
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(e);
  },
);
api.isAuthenticated = () => !!localStorage.getItem("token");
api.logout = () => {
  (localStorage.removeItem("token"),
    localStorage.removeItem("refreshToken"),
    window.dispatchEvent(new CustomEvent("auth:logout")));
};
export { api, isRefreshing, refreshQueue, processRefreshQueue, refreshAccessToken };
